import { useDisclosure, Checkbox } from '@chakra-ui/react'
import { format, parseISO } from 'date-fns'
import { FC, useMemo } from 'react'
import {
  AiOutlineClose,
  AiOutlineEye,
  AiOutlineEyeInvisible
} from 'react-icons/ai'
import { BsCheckLg } from 'react-icons/bs'
import { FaTruckLoading } from 'react-icons/fa'

import useFollowUpReabAlert from '@hook/alerts/use-followup-reab'
import useTable from '@hook/shared/use-table'

import TableGridItemAlertFollowUpReab from './item-followup-reab'
import TableGridFooterFollowUp from './item-footer'

const TableGridCollpseFollowUpReab: FC<{ filterDate: string }> = ({
  filterDate
}) => {
  const { data: rows } = useTable()
  const { atrasadoCheck, atencaoCheck, noprazoCheck, handleSelectAllFilter } =
    useFollowUpReabAlert()

  const ref = '#collapseOne'
  const { isOpen, onToggle } = useDisclosure()
  const attributes = ref ? { href: ref } : {}
  const firstObject = useMemo(() => {
    return rows.data.filter((x: any) => x['general-pedido'] === filterDate)[0]
  }, [rows, filterDate])

  const rowsMap = useMemo(() => {
    return rows.data.filter((x: any) => x['general-pedido'] === filterDate)
  }, [rows, filterDate])

  const count = useMemo(() => {
    return rows.data.filter((x: any) => x['general-pedido'] === filterDate)
      .length
  }, [rows, filterDate])

  const isVisible = useMemo(() => {
    if (firstObject['general-status-entrega'] === 2) {
      return !!atencaoCheck
    } else if (firstObject['general-status-entrega'] === 3) {
      return !!noprazoCheck
    } else {
      return !!atrasadoCheck
    }
  }, [firstObject, atrasadoCheck, noprazoCheck, atencaoCheck])

  return (
    <>
      {isVisible ? (
        <>
          <tr {...attributes} className="custom-display">
            <td align="center" valign="top" className="tr-gray">
              <Checkbox
                key={1}
                colorScheme="yellow"
                borderColor="blackAlpha.400"
                alignItems="center"
                onChange={() => {
                  handleSelectAllFilter(filterDate)
                }}
              />
            </td>
            <td
              align="center"
              valign="top"
              className="tr-gray"
              style={{
                cursor: 'pointer'
              }}
              onClick={onToggle}
            >
              {isOpen ? (
                <AiOutlineEyeInvisible size={20} />
              ) : (
                <AiOutlineEye size={20} />
              )}
            </td>
            <td colSpan={3} className="tr-gray">
              <b>
                {' '}
                {format(
                  parseISO(firstObject['general-data-criacao']),
                  'dd/MM/yyyy'
                )}{' '}
                - {firstObject['general-pedido']} -{' '}
                {firstObject['general-fornecedor-descricao']} - ({count})
              </b>
            </td>
            <td className="tr-gray" align="center">
              {() => {
                if (firstObject['general-status-entrega'] === '2') {
                  return <FaTruckLoading color="#3CB371" />
                } else if (firstObject['general-status-entrega'] === '3') {
                  return <FaTruckLoading color="#F0E68C " />
                } else {
                  return <FaTruckLoading color="#FA8072" />
                }
              }}
              <FaTruckLoading
                size={20}
                color={
                  firstObject['general-status-entrega'] === 2
                    ? '#3CB371'
                    : firstObject['general-status-entrega'] === 3
                    ? '#F0E68C'
                    : '#FA8072'
                }
              />
            </td>
            <td className="tr-gray" align="center">
              {firstObject['general-status'] === 1 ? (
                <AiOutlineClose color="black" size={25} />
              ) : (
                <BsCheckLg color="green" size={25} />
              )}
            </td>
            <td colSpan={7} className="tr-gray"></td>
          </tr>
          {isOpen ? (
            rows.data.length === 0 ? (
              <tr>
                <td colSpan={12} align="center">
                  Dados não encontrados
                </td>
              </tr>
            ) : (
              <>
                {rowsMap.map((row, key) => (
                  <TableGridItemAlertFollowUpReab
                    data={row}
                    key={`table-grid-${key + 1}`}
                    indexData={key}
                  />
                ))}
                <TableGridFooterFollowUp filterDate={filterDate} />
              </>
            )
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  )
}
export default TableGridCollpseFollowUpReab
